module.exports = __webpack_public_path__ + "static/media/dcon.0810da94.png";